import { render, staticRenderFns } from "./AuthenticationModal.vue?vue&type=template&id=79e12d12&scoped=true&"
import script from "./AuthenticationModal.vue?vue&type=script&lang=js&"
export * from "./AuthenticationModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationModal.vue?vue&type=style&index=0&id=79e12d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e12d12",
  null
  
)

export default component.exports